import * as Yup from "yup";
export const REFERRAL_TABS = [
  {
    label: "Referral In",
    value: "referral-in",
  },
  {
    label: "Referral Out",
    value: "referral-out",
  },
  {
    label: "Referral Providers",
    value: "referral-provider-list",
  },
];

export type ReferralFilters = {
  patientName: string | null;
  date: string | null;
  referral_from: string | null;
  referral_to: string | null;
  speciality: string | null;
  status: string | null;
  searchString: string | null;
  show_referral_in_out: string | null;
};
export const REFERRAL_FILTER_KEYS = [
  "date",
  "referral_from",
  "referral_to",
  "speciality",
  "show_referral_in_out",
];

const REFERRAL_STATUS_MAPPER = {
  PENDING: { status: "PENDING", label: "Pending" },
  ACCEPTED: { status: "ACCEPTED", label: "Accepted" },
  CLOSED: { status: "CLOSED", label: "Closed" },
  COMPLETED: { status: "COMPLETED", label: "Completed" },
  SCHEDULED: { status: "SCHEDULED", label: "Scheduled" },
  SENT: { status: "SENT", label: "Sent" },
};

export const REFERRAL_STATUS_OPTIONS = Object.values(
  REFERRAL_STATUS_MAPPER
).map((status) => ({
  value: status.status,
  label: status.label,
}));

export const DEFAULT_FILTERS = {
  patientName: null,
  referral_from: null,
  referral_to: null,
  date: null,
  speciality: null,
  status: null,
  searchString: null,
  show_referral_in_out: null,
};
export const REFERRAL_FILTER_INITIAL_EXPANDED = Object.entries(
  DEFAULT_FILTERS
).reduce((acc, [k]) => {
  acc[k] = false;
  return acc;
}, {} as Record<string, boolean>);

export const REFERRAL_PRIORITIES = [
  { value: "HIGH", label: "High" },
  { value: "MEDIUM", label: "Medium" },
  { value: "LOW", label: "Low" },
];

export const NEW_PROVIDER_VALIDATION_SCHEMA = Yup.object({
  firstName: Yup.string().required().label("First Name"),
  // birthDate: Yup.string().required().label("Birth Date"),
  lastName: Yup.string().required().label("Last Name"),
  gender: Yup.string().required().label("Gender"),
  email: Yup.string()
    .email()
    .matches(/.*@.+\..+/, "Email address must be a valid Email")
    .required()
    .label("Email"),
  mobileNumber: Yup.string().optional(),
  practiceName: Yup.string().required().label("Practice Name"),
});

export const REFERRAL_INITIAL_VALUES = {
  patient: undefined,
  referralFrom: undefined,
  referralTo: undefined,
  referralSpecialities: undefined,
  referralDate: null,
  referralPriority: "MEDIUM",
  referralReason: "",
  referralNote: "",
  referralDiagnosisCode: undefined,
  patientInsurance: undefined,
  referralDocument: undefined,
  referralDocumentName: undefined,
  referralAppointment: undefined,
};

export const NEW_REFERRAL_VALIDATION_SCHEMA = Yup.object({
  patient: Yup.object().required().label("Patient Name"),
  referralFrom: Yup.object().required().label("Referral From"),
  referralTo: Yup.object().required().label("Referral To"),
  referralSpecialities: Yup.object().label("Referral Speciality"),
  referralDate: Yup.string().required().label("Referral Date"),
  referralAppointment: Yup.object().nullable().label("Appointment"),
});

// Priority mapper with color mapping
export const PRIORITY_MAPPING = {
  HIGH: { color: "red", label: "High" },
  MEDIUM: { color: "orange", label: "Medium" },
  LOW: { color: "green", label: "Low" },
} as const;

export const getObjectFromList = (obj?: any[]) => {
  if (!obj || Object.keys(obj ?? {})?.length === 0) return undefined;

  return {
    value: Object.keys(obj ?? {})[0],
    label: Object.values(obj ?? {})[0],
  };
};

export type ReferralStatus = {
  referralStatus?: string;
  description?: string;
};
export const referralStatusInitialValues: ReferralStatus = {
  referralStatus: undefined,
  description: undefined,
};

export const REFERRAL_STATUS_VALIDATION_SCHEMA = Yup.object().shape({
  referralStatus: Yup.string().required("Status is required"),
  // description: Yup.string().required("Description is required"),
});
